<template>
	
	<div>
		<div v-if="device=='pc'">
		<box :customer="true" :autoLoad="true" :ref="boxRef" title="转出账户" :width="1000" :index="0" @hide="hide"
			@submit="submit" moduleName="bankaccount" :store="store" selectType="radio" @boxdataload="boxdataload" />
		</div>
		<div v-else>
			<phonebox :customer="true" :autoLoad="true" :ref="boxRef" title="转出账户" :width="1000" :index="0" @hide="hide"
				@submit="submit" moduleName="bankaccount" :store="store" selectType="radio" @boxdataload="boxdataload" />
		</div>
	</div>
	


</template>
<style scoped>
	/* 	.footer_button {
		position: relative;
		width: 100%;
		flex-direction: row;
		align-items: flex-end;
		justify-content: flex-end;
		margin-top: 10px;
	} */
</style>
<script>
	import box from '@_system/components/formcomponents/common/box/index.vue'
	import phonebox from '@_system/components/formcomponents/phone/box/index.vue'
	export default {
		props: {
			store: {
				type: Object,
				default: () => {
					return {}
				}
			},
			type: {
				default: () => {
					return 'order'
				}
			},
			customerid: {
				default: () => {
					return null
				}
			}
		},
		data() {
			return {
				index: 0,
				foreingKey: null,
				boxRef: 'box_' + Math.random(),
				box: null,
				boxConfig: {
					columns: [{
						type: "",
						field: 'acc_code',
						title: '账号编码',
						render: '$input',
					},{
						type: "",
						field: 'acc_name',
						title: '账号名称',
						render: '$input',
					},{
						type: "",
						field: 'inst_account',
						title: '账号',
						render: '',
					}, {
						type: "",
						field: 'parentName',
						title: '机构类型',
						render: ''
					}],
					pagerConfig: {
						currentPage: 1,
						pageSize: 100,
						enabled: false,
						pageSizes: [20, 50, 200],
						force: true
					},
				},

			}
		},
		created() {

		},
		mounted() {
			let box = this.$refs[this.boxRef]
			box.buttonShow = false
			this.box = box
			this.box.list = this.list
			this.box.show = this.show

		},
		watch: {

		},
		computed: {
			device() {
				return window.systemMethods.device()
			}
		},

		methods: {
			show() {
				if (this.box.getTable()) {
					this.box.getTable().commitProxy('query')
				}
			},
			initList() {
				if (!this.box.gridOptions) {
					this.box.initBox(this.boxConfig)
				}
			},
			list(page, form) {
				return new Promise((resolve, reject) => {
					this.$api.bankaccount.list({...form,type:'wln'}).then((res) => {
						resolve(res)
					}, () => {
						reject()
					})
				})
			},
			boxdataload(e) {
				this.$emit('boxdataload', e)
			},
			submit(e) {
				this.$emit('submit', e)
			},
			hide() {
				this.$emit('back')
			}
		},
		components: {
			box,
			phonebox
		}
	}
</script>
